import React from 'react';
import CrudTable from '../../components/common/CrudTable';
import { commentAPI } from '../../api/services';

const COLUMNS = [
  { key: 'text', label: 'Comment', render: (item) => item.text?.length > 60 ? item.text.substring(0, 60) + '...' : item.text },
  { key: 'userName', label: 'User' },
  { key: 'createdAt', label: 'Date', render: (item) => item.createdAt?.substring(0, 10) || '—' },
];

const FORM_FIELDS = [
  { name: 'text', label: 'Comment Text', type: 'textarea', placeholder: 'Write a comment...' },
];

const CommentsAdmin = () => (
  <CrudTable
    title="Comments"
    entityName="Comment"
    columns={COLUMNS}
    formFields={FORM_FIELDS}
    fetchData={async () => {
      const res = await commentAPI.getAll();
      return res.data?.data || [];
    }}
    onAdd={(data) => commentAPI.add(data)}
    onUpdate={(id, data) => commentAPI.update(id, data)}
    onDelete={(id) => commentAPI.delete(id)}
  />
);

export default CommentsAdmin;
